// Dependencies
import styled from 'styled-components'

// Utils
import { MediaQueries } from 'utils/breakpoints'
import { pageGutter } from 'styles/gutter'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 24px 0;
  background-color: #eceeee;

  ${MediaQueries.medium} {
    ${pageGutter};
  }

  ${MediaQueries.notebook} {
    gap: 80px;
  }
`

export const Content = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  justify-content: center;
  margin: 0px auto;

  ${MediaQueries.medium} {
    width: 677px;
    justify-content: space-between;
  }

  ${MediaQueries.amedium} {
    width: 972px;
  }

  ${MediaQueries.notebook} {
    width: 1291px;
  }

  ${MediaQueries.fullhd} {
    width: 1621px;
  }
`

export const TitleWrapper = styled.div`
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;

  ${MediaQueries.notebook} {
    gap: 24px;

    max-width: 1175px;
  }
`

export const Title = styled.p`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  color: #000;
`

export const SubTitle = styled.p`
  color: #25272d;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;

  ${MediaQueries.notebook} {
    font-family: 'Inter', sans-serif;
    font-size: 32px;
    line-height: 48px;
  }
`

export const PricetablesWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  width: 100%;

  ${MediaQueries.notebook} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
